enum QueryEnum {
  Manufacturer = 'f.manufacturer',
  ProductVariant = 'productVariant',
  ComponentHint = 'componentHint',
  Discount = 'f.discount_percentage',
  Redirect = 'redirect',
  QueryKey = 'queryKey',
  SearchText = 'searchText',
  S = 's',
  Az = 'az',
}

export default QueryEnum
